export default {
  loggedIn(state, payload) { state.loggedIn = payload; return state; },
  person(state, payload) { state.person = payload; return state; },
  phase(state, payload) { state.phase = payload; return state; },
  authEmail(state, payload) { state.authEmail = payload; return state; },
  authBusy(state, payload) { state.authBusy = payload; return state; },
  authStatus(state, payload) { state.authStatus = payload; return state; },
  endpointStatus(state, payload) { state.endpointStatus = payload; return state; },
  acceptMessage(state, payload) { state.acceptMessage = payload; return state; },
};
